export default "__VITE_ASSET__Crt07SWZ__"